import React from 'react';
import { TableRemissionHistory } from './TableRemissionHistory';
import useReplicasManagementModal from '../../hooks/useReplicasManagementModal';

const BodyModal = ({ actionText, document }) => {
  return (
    <>
      <h4 className={'text-center'}>
        ¿Deseas <b>{actionText}</b> la resolución al Juzgado de Primera Instancia?
      </h4>
      <TableRemissionHistory id_document={document.id} />
    </>
  );
};

export default BodyModal;
